import React, { useState, useEffect, useRef } from 'react';
import SurveyService from '../../services/survey.service';
import PropTypes from 'prop-types';
import UserService from "../../services/user.service"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass, faPlus, faPlusCircle, faRefresh, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { CreditCard, User2Icon } from "lucide-react"

const AdminPatientTherapists = ({ userId }) => {

  const [therapist, setTherapist] = useState(undefined);
  const [therapistsList, setTherapistsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTherapist, setLoadingTherapist] = useState(false);
  const [loadingTherapists, setLoadingTherapists] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('')
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    if (userId) {
      loadUserTherapist();
    }
  }, [userId]);

  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    if (searchTerm.length > 3) {
      debounceTimeoutRef.current = setTimeout(() => {
        setTherapistsList([])
        searchTherapists();
      }, 1500);
    }

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  const loadUserTherapist = async () => {
    try {
      setLoadingTherapist(true);

      const userResponses = await UserService.getUserTherapist(userId);
      console.log('Risposte ricevute:', userResponses);
      setTherapist(userResponses[0]);

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);
    } finally {
      setLoadingTherapist(false);
    }
  };

  const searchTherapists = async () => {
    try {
      setLoadingTherapists(true);

      const res = await UserService.getTherapists(searchTerm);
      setTherapistsList(res);

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);
    } finally {
      setLoadingTherapists(false);
    }
  };

  const associateTherapistsReq = async (therapistId) => {
    try {
      setLoading(true)

      const res = await UserService.associateTherapistAndUser(userId, therapistId);
      console.log('Risposte ricevute:', res);

      alert('Terapista associato correttamente')
      loadUserTherapist();

      setError('');
    } catch (err) {
      console.error('Errore nel caricamento:', err);

      alert('Si è verificato un errore nell\'associazione del terapista');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
          {error}
        </div>
      )}

      {
        !loadingTherapist &&
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-purple-100 mr-4">
              <User2Icon className="h-6 w-6 text-purple-600"/>
            </div>
            <div>
              <p className="text-sm text-gray-500">
                {
                  therapist ?
                    'Attuale professionista associato'
                    :
                    'Nessun professionista associato'
                }
              </p>
              {
                therapist &&
                <p className="text-lg font-semibold">{therapist.user?.first_name} {therapist.user?.last_name} - {therapist.user.email}</p>
              }
            </div>
          </div>
        </div>
      }

      <div className="mt-4 mb-4 relative">
        <input
          type="text"
          placeholder="Cerca per email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-3 pl-10 border rounded-lg"
          disabled={loadingTherapists}
        />
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
      </div>

      {
        loadingTherapists &&
        <div className="flex justify-center items-center h-32">
          <p className="text-gray-500">Caricamento lista terapisti</p>
        </div>
      }

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {therapistsList.map((item) => (
          <div key={item.id} className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow">
            <div className="flex justify-between items-start">
              <div>
                <h2 className="font-semibold truncate">{item.first_name} {item.last_name}</h2>
                <p className="text-sm text-gray-600 truncate">{item.email}</p>
                <p className="text-sm text-gray-600">{item.phone}</p>
                {/*<p className="text-sm text-gray-600">{item.specialization}</p>*/}
              </div>
              <button
                disabled={loading}
                onClick={() => associateTherapistsReq(item.id)}
                className={`bg-blue-500 text-white p-2 rounded hover:bg-blue-600 ${(loading) ? 'opacity-30' : ''}`}
              >
                <FontAwesomeIcon icon={faRefresh}/>
              </button>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

AdminPatientTherapists.propTypes = {
  userId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};

export default AdminPatientTherapists;
